module.exports = __webpack_public_path__ + "img/@anyacahyara.49ff40f3.png";